var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPETROLPRICES = CONFUSEDPETROLPRICES || {};
CONFUSEDPETROLPRICES.UiElements = CONFUSEDPETROLPRICES.UiElements || {};

(function (ns, $) {
    'use strict';

    // html elements
    ns.Elements = {
        SFFuelFinderLandingPanel: '.petrol-price-calculator__landing-panel',
        PRFuelFinderResultsPanel: '.petrol-price-calculator__results-panel',
        ScrollLeftLink: '.petrol-price-results__link--left',
        ScrollRightLink: '.petrol-price-results__link--right',
        ScrollRightBodyMarker: '.scroll-end-marker--body',
        ResultsUl: '.petrol-price-results',
        ResultsUlItems: '.petrol-price-results > li',
        ResultsFill: '.results-fill',
        PetrolPriceResultsResult: '.petrol-price-results__result',
        ScrollEndMarkerResult: '.scroll-end-marker--result',
        OpeningHoursModal: '.opening-times-modal',
        Dimmer: '.dimmer',
        ResultsPanelBody: '#resultsPanelBody',
        TooltipToggle: '.tooltip-toggle',
        TooltipWrapper: '.tooltip-wrapper',
        TooltipInfo: '.tooltip-info',
        TooltipInfoDismiss: '.tooltip-info__dismiss',
        ResultSectionAddress: '.petrol-price-results__result__section__address',
        ResultSectionLoggedOut: '.petrol-price-results__result__section--logged-out',
        RSCurrentLocationTooltipWrapper: '#rsCurrentLocationTooltipWrapper',
        RSPostcodeError: '#rsPostcodeError',
        RSFuelType: '#rsFuelType',
        RSRadius: '#rsRadius',
        SFPostcodeWrapper: '.postcode-wrapper',
        SFGetPrices: '#sfGetPrices',
        SFLandingPanelMainPostcode: '.petrol-price-calculator__landing-panel__main__postcode',
        CheapestRibbon: '.cheapest-ribbon',
        SortPricesByDistance: '#sortPricesByDistance'
    };

    // classes
    ns.Classes = {
        ResultsPanelBodyBorder: 'petrol-price-calculator__results-panel__body_border',
        OpeningHoursLinkClicked: 'opening-hours-link-clicked'
    };

    // constants
    ns.Constants = {
        Left: 'left',
        MarginLeft: 'margin-left',
        MarginRight: 'margin-right',
        MarginTop: 'margin-top',
        MarginBottom: 'margin-bottom',
        Pixel: 'px',
        Height: 'height',
        Open: 'open',
        Visible: ':visible',
        MaxWidth: 'max-width',
        Border: 'border',
        Disabled: 'disabled',
        MsIe: 'MSIE ',
        MsIe11: 'Trident/',
        Macintosh: 'Macintosh ',
        Safari: 'Safari',
        Chrome: 'Chrome',
        IPad: 'iPad',
        IPod: 'iPod',
        IPhone: 'iPhone',
        ResultWidth: 240
    };

    // utils functions
    ns.Utils = {

        // clear address height
        ClearAddressHeight: function () {

            // get all list items
            var listItem = $(ns.Elements.ResultsUlItems);

            // clear height of each address item
            listItem.each(function () {
                $(this).find(ns.Elements.ResultSectionAddress).css(ns.Constants.Height, '');
            });
        },

        // clear price list height
        ClearPriceListHeight: function () {

            // get all list items
            var listItem = $(ns.Elements.ResultsUlItems);

            // clear height of each list item
            listItem.each(function () {
                $(this).css(ns.Constants.Height, '');
            });

            // clear height of each logged out item
            listItem.each(function() {
                $(this).find(ns.Elements.ResultSectionLoggedOut).css(ns.Constants.Height, '');
            });

            // clear height of results fill
            $(ns.Elements.ResultsFill).css(ns.Constants.Height, '');

            // clear height of list
            $(ns.Elements.ResultsUl).css(ns.Constants.Height, '');

            // clear height of results panel
            $(ns.Elements.ResultsPanelBody).css(ns.Constants.Height, '');

            // clear height of dimmer
            $(ns.Elements.Dimmer).css(ns.Constants.Height, '');
        },

        // set address height
        SetAddressHeight: function () {

            // get all list items
            var listItem = $(ns.Elements.ResultsUlItems);

            // get max height of address items
            var maxHeight = 0;
            listItem.each(function () {
                var thisHeight = $(this).find(ns.Elements.ResultSectionAddress).outerHeight();

                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            // ensure address items found
            if (maxHeight === 0) {
                return;
            }

            // set height of each address item
            listItem.each(function () {
                $(this).find(ns.Elements.ResultSectionAddress).css(ns.Constants.Height, maxHeight);
            });
        },

        // set price list height
        SetPriceListHeight: function () {

            // get all list items
            var listItem = $(ns.Elements.ResultsUlItems);

            // get max height of list items
            var maxHeight = 0;
            listItem.each(function () {
                var thisHeight = $(this).outerHeight();

                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            // ensure list items found
            if (maxHeight === 0) {
                return;
            }

            // set height of each list item
            listItem.each(function () {
                $(this).css(ns.Constants.Height, maxHeight);
            });

            // set height of each logged out item
            var loggedOutItemHeight;
            if ($(window).width() > 900) {
                loggedOutItemHeight = maxHeight - 139;
            } else {
                loggedOutItemHeight = maxHeight - 119;
            }

            listItem.each(function() {
                $(this).find(ns.Elements.ResultSectionLoggedOut).css(ns.Constants.Height, loggedOutItemHeight);
            });

            // set height of results fill
            $(ns.Elements.ResultsFill).css(ns.Constants.Height, maxHeight);

            // set height of list
            $(ns.Elements.ResultsUl).css(ns.Constants.Height, maxHeight + 1);

            // set height of results panel
            if ($(window).width() > 600) {
                $(ns.Elements.ResultsPanelBody).css(ns.Constants.Height, maxHeight + 1);
            } else {
                $(ns.Elements.ResultsPanelBody).css(ns.Constants.Height, maxHeight + 21);
            }

            // set height of dimmer
            $(ns.Elements.Dimmer).css(ns.Constants.Height, maxHeight + 1);
        }
    };

    // search form to prices
    CONFUSEDPETROLPRICES.searchFormToPrices = function () {
        $(ns.Elements.SFFuelFinderLandingPanel).hide();
        $(ns.Elements.PRFuelFinderResultsPanel).show();
    };

    // prices form to directions
    CONFUSEDPETROLPRICES.pricesFormToDirections = function () {

        // clear price list height
        ns.Utils.ClearPriceListHeight();

        // hide results panel border
        CONFUSEDPETROLPRICES.hideResultsPanelBorder();
    };

    // directions form to prices
    CONFUSEDPETROLPRICES.directionsFormToPrices = function () {

        // set price list height
        ns.Utils.SetPriceListHeight();

        // show results panel border
        CONFUSEDPETROLPRICES.showResultsPanelBorder();
    };

    // prices form to search
    CONFUSEDPETROLPRICES.pricesFormToSearch = function () {
        $(ns.Elements.PRFuelFinderResultsPanel).hide();
        $(ns.Elements.SFFuelFinderLandingPanel).show();
    };

    // prices on render
    CONFUSEDPETROLPRICES.scrollablePricesOnRender = function (numberOfPrices) {
        ns.Utils.ClearAddressHeight();
        ns.Utils.ClearPriceListHeight();

        var resultLiWidth = $(ns.Elements.PetrolPriceResultsResult).width() + 2;
        var pricesWidth = resultLiWidth * numberOfPrices;
        var pricesWidthMinusOne = resultLiWidth * (numberOfPrices - 1);

        if ($(window).width() > 583) {
            $(ns.Elements.ResultsUl).width(pricesWidthMinusOne);
            $(ns.Elements.ResultsUl).css(ns.Constants.MarginLeft, ns.Constants.ResultWidth);

            if ($(ns.Elements.PRFuelFinderResultsPanel).width() > pricesWidth) {
                $(ns.Elements.ScrollRightLink).hide();
            } else {
                $(ns.Elements.ScrollRightLink).show();
            }

            $(ns.Elements.ScrollLeftLink).hide();
        }
        else {
            $(ns.Elements.ResultsUl).width(pricesWidth);
            $(ns.Elements.ResultsUl).css(ns.Constants.MarginLeft, 0);
            $(ns.Elements.ScrollLeftLink).hide();
            $(ns.Elements.ScrollRightLink).hide();
        }

        ns.Utils.SetAddressHeight();
        ns.Utils.SetPriceListHeight();

        CONFUSEDPETROLPRICES.HandleCheapestRibbonOnTimeout();
    };

    // prices on right click
    CONFUSEDPETROLPRICES.scrollablePricesOnRightClick = function (e) {
        e.preventDefault();
        
        if ($(ns.Elements.ScrollRightLink).prop(ns.Constants.Disabled)) {
            return;
        }
        $(ns.Elements.ScrollRightLink).prop(ns.Constants.Disabled, true);

        var currentLeftMargin = $(ns.Elements.ResultsUl).css(ns.Constants.MarginLeft).replace(ns.Constants.Pixel, ''),
            scrollRightResultMarkerOffset = $(ns.Elements.ScrollEndMarkerResult).offset(),
            scrollRightBodyMarkerOffset = $(ns.Elements.ScrollRightBodyMarker).offset(),
            newLeftMargin = parseInt(currentLeftMargin) - ns.Constants.ResultWidth;

        if (scrollRightResultMarkerOffset.left > scrollRightBodyMarkerOffset.left) {
            $(ns.Elements.ResultsUl).css(ns.Constants.MarginLeft, newLeftMargin + ns.Constants.Pixel);
            CONFUSEDPETROLPRICES.HandleCheapestRibbon(240);
        }
        else {
            $(ns.Elements.ScrollRightLink).fadeOut(300);
        }
        $(ns.Elements.ScrollLeftLink).fadeIn(300);

        setTimeout(function () {
            $(ns.Elements.ScrollRightLink).prop(ns.Constants.Disabled, false);
        }, 300);
    };

    // prices on left click
    CONFUSEDPETROLPRICES.scrollablePricesOnLeftClick = function (e) {
        e.preventDefault();

        if ($(ns.Elements.ScrollLeftLink).prop(ns.Constants.Disabled)) {
            return;
        }
        $(ns.Elements.ScrollLeftLink).prop(ns.Constants.Disabled, true);

        var currentLeftMargin = $(ns.Elements.ResultsUl).css(ns.Constants.MarginLeft).replace(ns.Constants.Pixel, ''),
            newLeftMargin = parseInt(currentLeftMargin) + ns.Constants.ResultWidth,
            marginBoundary = 0;

        if ($(window).width() > 583) {
            marginBoundary = ns.Constants.ResultWidth;
            if (newLeftMargin >= ns.Constants.ResultWidth) {
                $(ns.Elements.ScrollLeftLink).fadeOut(300);
            }
        }

        if (parseInt(currentLeftMargin) < marginBoundary) {
            if (newLeftMargin > ns.Constants.ResultWidth) {
                newLeftMargin = ns.Constants.ResultWidth;
            }
            $(ns.Elements.ResultsUl).css(ns.Constants.MarginLeft, newLeftMargin + ns.Constants.Pixel);
            $(ns.Elements.ScrollRightLink).fadeIn(300);
        }

        setTimeout(function () {
            $(ns.Elements.ScrollLeftLink).prop(ns.Constants.Disabled, false);
        }, 300);

        CONFUSEDPETROLPRICES.HandleCheapestRibbonOnTimeout();
    };

    // handle cheapest ribbon on timeout
    CONFUSEDPETROLPRICES.HandleCheapestRibbonOnTimeout = function () {
        setTimeout(function () {
            CONFUSEDPETROLPRICES.HandleCheapestRibbon(0);
        }, 400);
    };

    // handle cheapest ribbon
    CONFUSEDPETROLPRICES.HandleCheapestRibbon = function (leftMargin) {

        // if: not desktop OR not sorted by distance OR static price has ribbon
        if ($(window).width() <= 583 ||
            $(ns.Elements.SortPricesByDistance).hasClass('results-filter--active') === false ||
            $($(ns.Elements.PetrolPriceResultsResult).first()[0]).find(ns.Elements.CheapestRibbon).length > 0) {

            // show ribbon
            $(ns.Elements.PetrolPriceResultsResult).each(function () {
                $(this).find(ns.Elements.CheapestRibbon).show();
            });

        } else {

            // hide ribbon (where scrollable price underlaps static price)
            $(ns.Elements.PetrolPriceResultsResult).each(function (index) {
                if ($(this).position().left <= leftMargin && index !== 0) {
                    $(this).find(ns.Elements.CheapestRibbon).hide();
                } else {
                    $(this).find(ns.Elements.CheapestRibbon).show();
                }
            });
        }
    };

    // opening hours link click
    CONFUSEDPETROLPRICES.openingHoursLinkClick = function () {

        // if mobile, place opening hours modal at correct scroll position
        if ($(window).width() <= 600) {
            var scrollLeft = $(ns.Elements.ResultsPanelBody).scrollLeft() + 40;
            $(ns.Elements.OpeningHoursModal).css(ns.Constants.Left, scrollLeft + ns.Constants.Pixel);
        }

        // ensure dimmer fills results panel
        var resultsPanelWidth = $(ns.Elements.PRFuelFinderResultsPanel).width();
        var resultsUlWidth = $(ns.Elements.ResultsUl).width() + ns.Constants.ResultWidth;
        if (resultsPanelWidth > resultsUlWidth) {
            $(ns.Elements.Dimmer).width(resultsPanelWidth);
        } else {
            $(ns.Elements.Dimmer).width('150%');
        }

        $(ns.Elements.OpeningHoursModal).fadeIn(300);
        $(ns.Elements.Dimmer).fadeIn(300);
        $(ns.Elements.OpeningHoursModal).addClass(ns.Classes.OpeningHoursLinkClicked);
    };

    // opening hours modal close click
    CONFUSEDPETROLPRICES.openingHoursModalCloseClick = function () {
        $(ns.Elements.OpeningHoursModal).fadeOut(300);
        $(ns.Elements.Dimmer).fadeOut(300);
    };

    // show results panel border
    CONFUSEDPETROLPRICES.showResultsPanelBorder = function () {
        $(ns.Elements.ResultsPanelBody).addClass(ns.Classes.ResultsPanelBodyBorder);
    };

    // hide results panel border
    CONFUSEDPETROLPRICES.hideResultsPanelBorder = function () {
        $(ns.Elements.ResultsPanelBody).removeClass(ns.Classes.ResultsPanelBodyBorder);
    };

    // initialise tooltips
    CONFUSEDPETROLPRICES.initTooltips = function () {

        $(ns.Elements.TooltipToggle).click(function (e) {
            if ($(this).hasClass(ns.Constants.Open)) {
                $(this).closest(ns.Elements.TooltipWrapper).find(ns.Elements.TooltipInfo).fadeOut();
                $(this).removeClass(ns.Constants.Open);
            }
            else {
                $(ns.Elements.TooltipToggle).removeClass(ns.Constants.Open);
                $(ns.Elements.TooltipInfo).fadeOut();
                $(this).closest(ns.Elements.TooltipWrapper).find(ns.Elements.TooltipInfo).fadeIn();
                $(this).addClass(ns.Constants.Open);
            }
            e.preventDefault();
        });

        $(ns.Elements.TooltipInfoDismiss).click(function(e) {
            $(this).closest(ns.Elements.TooltipInfo).fadeOut();
            $(ns.Elements.TooltipToggle).removeClass(ns.Constants.Open);
            e.preventDefault();
        });
    };

    // initialise opening hours
    CONFUSEDPETROLPRICES.initOpeningHours = function () {

        // on price list click
        $(ns.Elements.ResultsUl).click(function () {
            var openingHoursLinkClicked = $(ns.Elements.OpeningHoursModal).hasClass(ns.Classes.OpeningHoursLinkClicked);

            // if dimmer visible (and not due to opening hours link being clicked)
            if ($(ns.Elements.Dimmer).is(ns.Constants.Visible) &&
                openingHoursLinkClicked === false) {

                // close opening hours modal
                CONFUSEDPETROLPRICES.openingHoursModalCloseClick();

            // otherwise remove opening hours link clicked
            } else if (openingHoursLinkClicked) {
                    $(ns.Elements.OpeningHoursModal).removeClass(ns.Classes.OpeningHoursLinkClicked);
            }
        });
    };

    // show search form postcode section
    CONFUSEDPETROLPRICES.showSearchFormPostcodeSection = function () {
        $(ns.Elements.SFLandingPanelMainPostcode).fadeIn();
    };

    // initialise internet explorer
    CONFUSEDPETROLPRICES.initInternetExplorer = function () {

        // ensure internet explorer
        if (!CONFUSEDPETROLPRICES.isInternetExplorer()) {
            return;
        }

        // handle search form postcode and get prices width
        $(ns.Elements.SFPostcodeWrapper).css(ns.Constants.MaxWidth, 300);
        $(ns.Elements.SFGetPrices).css(ns.Constants.MaxWidth, 250);

        // handle results form current location positioning
        $(ns.Elements.RSCurrentLocationTooltipWrapper).css(ns.Constants.MarginLeft, -250);
        $(ns.Elements.RSCurrentLocationTooltipWrapper).css(ns.Constants.MarginTop, 50);
        $(ns.Elements.RSPostcodeError).css(ns.Constants.MarginBottom, -40);
    };

    // initialise safari on mac
    CONFUSEDPETROLPRICES.initSafariOnMac = function () {

        // ensure safari on mac
        if (!CONFUSEDPETROLPRICES.isSafariOnMac()) {
            return;
        }

        // handle search form postcode and get prices width
        $(ns.Elements.SFLandingPanelMainPostcode).css(ns.Constants.MarginLeft, '28%');
        $(ns.Elements.SFLandingPanelMainPostcode).css(ns.Constants.MarginRight, '28%');

        // handle prices search fuel type and radius
        $(ns.Elements.RSFuelType).css(ns.Constants.Border, 1);
        $(ns.Elements.RSFuelType).css(ns.Constants.MarginTop, 10);
        $(ns.Elements.RSRadius).css(ns.Constants.Border, 1);
        $(ns.Elements.RSRadius).css(ns.Constants.MarginTop, 10);
    };

    // check if internet explorer
    CONFUSEDPETROLPRICES.isInternetExplorer = function () {
        var ua = window.navigator.userAgent;
        var isMsIe = ua.indexOf(ns.Constants.MsIe) !== -1;
        var isMsIe11 = ua.indexOf(ns.Constants.MsIe11) !== -1;

        if (!isMsIe && !isMsIe11) {
            return false;
        }

        return true;
    };

    // check if safari on mac
    CONFUSEDPETROLPRICES.isSafariOnMac = function () {
        var ua = window.navigator.userAgent;
        var isMacintosh = ua.indexOf(ns.Constants.Macintosh) !== -1;
        var isSafari = ((ua.indexOf(ns.Constants.Safari) !== -1) && (ua.indexOf(ns.Constants.Chrome) === -1));
        var isIPad = ua.indexOf(ns.Constants.IPad) !== -1;
        var isIPod = ua.indexOf(ns.Constants.IPod) !== -1;
        var isIPhone = ua.indexOf(ns.Constants.IPhone) !== -1;

        if ((!isMacintosh && !isSafari) || (isIPad || isIPod || isIPhone)) {
            return false;
        }

        return true;
    };

}(CONFUSEDPETROLPRICES.UiElements, jQuery));